module.exports = __webpack_public_path__ + "static/gallery_west_street_1_thumb-1a7ac9476b3567175ff6975a8a99cd0e.jpg";